import React from 'react';
import './homepage.css';
import { useState } from 'react';
import logo from '../Images/Sample.png';
import Navbar from './Navbar';
import bgImg from '../Images/background.webp';
import { width } from '@mui/system';
import nd from '../Images/2nd Picture.webp';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css"; 
import Footer from './footer';
import product1 from '../Images/product1.webp'
import product2 from '../Images/product2.webp'
import product3 from '../Images/product3.webp'
import carousel4 from '../Images/slider.jpg'
import newsletter from '../Images/newsletter.png'
import { Link } from 'react-router-dom';
import { ArrowRightCircle } from 'react-bootstrap-icons';
import carousel1 from '../Images/carousel1.png'
import carousel2 from '../Images/carousel2.png'
import carousel3 from '../Images/carousel3.png'



const arrowStyles: CSSProperties = {
  zIndex: 2,
  top: "0",
  color: "#fff",
  bottom: "0",
  marginTop: "0",
  padding: "5px",
  right: "0",
  position: "absolute",
  backgroundColor: "rgb(0,0,0,0)",
  border: "none",
  color: "white",
};
const arrowStylesP: CSSProperties = {
  zIndex: 2,
  top: "0",
  color: "#fff",
  bottom: "0",
  marginTop: "0",
  padding: "5px",
  left: "0",
  position: "absolute",
  backgroundColor: "rgb(0,0,0,0)",
  border: "none",
  color: "white",
};

const products = [
  {
    id: 1,
    title: 'Canva Backpack',
    url: "https://static.wixstatic.com/media/a9ff3b_f852b0f8d589446d9b672173e24008f9.jpg/v1/fill/w_827,h_827,al_c,q_85,usm_0.66_1.00_0.01/a9ff3b_f852b0f8d589446d9b672173e24008f9.webp",
    imgSrc: product1,
    discountedPrice: 70.58,
    description: "This is the best product of the world",
    price: 65.50
  },
  {
    id: 2,
    title: 'Canva Backpack',
    url: "https://static.wixstatic.com/media/a9ff3b_b0e020a191534969bccc74fb5f27684c.jpg/v1/fill/w_827,h_827,al_c,q_85,usm_0.66_1.00_0.01/a9ff3b_b0e020a191534969bccc74fb5f27684c.webp",
    discountedPrice: 70.58,
    description: "This is the best product of the world",
    price: 65.50
  },
  {
    id:3,
    title: 'Canva Backpack',
    url: "https://static.wixstatic.com/media/84770f_7b18884ff3e343208842ae1f30df28aa.jpg/v1/fill/w_827,h_827,al_c,q_85,usm_0.66_1.00_0.01/84770f_7b18884ff3e343208842ae1f30df28aa.webp",
    discountedPrice: 70.58,
    description: "This is the best product of the",
    price: 65.50
  }
];


export default function Homepage() {
  const [display, setDisplay] = useState(null);
  return (
    <>

            <Carousel className='carousel' showThumbs={false} showIndicators={false}
             autoPlay={true} showStatus={false} infiniteLoop={true} interval={1500}
             renderArrowNext={(onClickHandler, hasPrev, label) =>
              hasPrev && (
                <button
                  type="button"
                  onClick={onClickHandler}
                  title={label}
                  style={{
                    ...arrowStyles,
                  }}
                >
                  <span className="material-symbols-outlined" style={{fontSize: "1.5rem",fontWeight: "bolder"}}
                  >arrow_forward_ios</span>
                </button>
              )
            }
             renderArrowPrev={(onClickHandler, hasPrev, label) =>
              hasPrev && (
                <button
                  type="button"
                  onClick={onClickHandler}
                  title={label}
                  style={{
                    ...arrowStylesP,
                  }}
                >
                  <span className="material-symbols-outlined" style={{fontSize: "1.5rem",fontWeight: "bolder"}}
                  >arrow_back_ios</span>
                </button>
              )
            }
              >
              <div>
                <img src="https://i.ibb.co/0tNpcpc/carousel1.png" style={{height: "auto",width: "100%",background: "cover"}}></img>
              </div>
              <div>
                <img src="https://i.ibb.co/4ZCnPyD/carousel2.png" style={{height: "auto",width: "100%",background: "cover"}}></img>
              </div>
              <div>
                <img src="https://i.ibb.co/FqRB5c5/carousel3.png" style={{}}></img>
              </div>
              {/* <div>
                <img src={carousel4}></img>
                <p className='legend' style={{color: "white",backgroundColor: "none",opacity: "1",background: "none",fontSize: "2rem"}} >Legend 4</p>
              </div> */}
            </Carousel>

            
            <div className='container-fluid col-md-12 secondPicture'>
      <div className=' secondPicBlack'>
        <h1>New Arrivals</h1>
        <Link to="/shop" className='secondPicBlacka'>Buy Now</Link>
      </div>
      <div className='secondPicImg'>
        <img src={nd} style={{width:"100%",maxHeight:"100vh",objectFit: "cover"}} ></img>
      </div>
    </div> 
    {/* On Sale Product */}
    <div className='container-fluid col-md-12 Sale'>
  <h1 className='text-center'>Now on Sale</h1>
  <h2 className='text-center'>UP T0 50% OFF</h2>
  <div className='products'>
  {products.map(item => (
        <div className="shopping-item col-md-4 my-2" key={item.id}
        style={{backgroundColor: "black"}}
            onMouseOver={()=>{setDisplay(item.id)}} onMouseLeave={()=>{setDisplay(null)}}>
              <Link to='/product' state={{item}} className='container' style={{}}>

          <img src={item.url}
          // src={item.image} 
          alt={item.name} width="100%" height="auto" className='image'
          onMouseOver={()=>{setDisplay(item.id)}} onMouseLeave={()=>{setDisplay(null)}}>
          </img>
          <div className='button' >
          {display === item.id && (
            <>
                  <Link className="btn addToCart" to='/product' state={{item}} style={{color:'black', transition: "all 1s ease-in-out",padding: 0,margin: 0 }}
                     >View Product Details</Link>
                  {/* <Link className='btn addToCart'
                    to={{
                      pathname: `${match.url}/product`,
                      state: { prop1: 'Hello' },
                    }}
                    render={(props) => <Product {...props} />}
                  >
                    My Component
                  </Link> */}
                </>
            )}
            </div>
            </Link>
            {/* <div class="container">
  <img src="https://images.unsplash.com/photo-1488628075628-e876f502d67a?dpr=1&auto=format&fit=crop&w=1500&h=1000&q=80&cs=tinysrgb&crop=&bg=" alt="" />
  <div class="button"><a href="#"> BUTTON </a></div>
</div> */}
          <h5 className='product-title' style={{fontFamily: "font"}}>{item.title}</h5>
          {item.discountedPrice ? (
            <>
              <p className="original-price" style={{fontFamily: "font"}} ><del>${item.price}</del> <span className='mx-2'> ${item.discountedPrice}</span></p>
            </>
          ) : (
            <>
            <p style={{fontFamily: "font"}}>${item.price}</p>
            </>
            )}
          {/* <p>{item.dicountedPrice}</p> */}
        </div>
      ))}
  </div>
</div>



  {/* Newsletter */}
  <div className='newsletter'>
    <img src={newsletter} className="col-md-6"></img>
    <div className='col-md-6'>
    <form className='newsletterF '>
    <h1>Subscribe to Our NewsLetter!</h1>
    <p>Subscribe to our Newsletter 
    and Stay Updated</p>
    <div className="col-auto">
    <label className="visually-hidden" htmlFor="autoSizingInputGroup">Username</label>
    <div className="input-group">
      <div className="input-group-text">@</div>
      <input type="text" className="form-control" id="autoSizingInputGroup" placeholder="Username"/>
    </div>
  </div><br></br>
    <button className='btn newsletter-btn w-100'>Subscribe</button>
    </form>
    </div>
  </div>
    </>
  )
}
